/**
 * @generated SignedSource<<703e33670c3bc0d50ec31016df028bf8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RecipientPartner_company$data = {
  readonly activePartners: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly displayName: string;
        readonly id: string;
      } | null;
    } | null>;
  };
  readonly " $fragmentType": "RecipientPartner_company";
};
export type RecipientPartner_company$key = {
  readonly " $data"?: RecipientPartner_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"RecipientPartner_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecipientPartner_company",
  "selections": [
    {
      "alias": "activePartners",
      "args": [
        {
          "kind": "Literal",
          "name": "isActive",
          "value": true
        }
      ],
      "concreteType": "PartnerNodeConnection",
      "kind": "LinkedField",
      "name": "partners",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PartnerNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PartnerNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayName",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "partners(isActive:true)"
    }
  ],
  "type": "CompanyNode",
  "abstractKey": null
};

(node as any).hash = "54eff4ded4bc728bd6da1eb6f01b2a41";

export default node;
